import { render, staticRenderFns } from "./CIGLokasi.vue?vue&type=template&id=19bf5c04&"
import script from "./CIGLokasi.vue?vue&type=script&lang=js&"
export * from "./CIGLokasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports